module.exports = __webpack_public_path__ + "img/phon1.d1ed181f.png";